/**
 * Input placeholders and helper text for forms.
 */
export const placeholders = {
  assignments: {
    title: "e.g., Persuasive Essay on Climate Change",
    instructions: "Optional instructions that will be shown to students...",
    selectClass: "Select a class...",
    selectPaperType: "Select paper type...",
  },

  classes: {
    name: "e.g., Period 3 English",
    defaultGrade: "Select default grade level...",
  },

  students: {
    name: "Student name",
    gradeLevel: "Select grade level...",
  },

  documents: {
    pasteContent: "Paste the paper here...",
    selectStudent: "Select a student...",
  },

  criteria: {
    label: "e.g., Thesis Statement",
    humanDescription: "Explain to the student what was found and how to improve it...",
    llmDescription: "Give the checker clear instructions to locate and evaluate this focus area in the paper...",
    generateInput: "Describe criteria you want to generate (e.g., 'thesis statement, evidence, citations')",
    generatorPrompt: (gradeLevel?: string | null) => {
      const grade = gradeLevel ? parseInt(gradeLevel, 10) : null;

      if (grade && grade >= 3 && grade <= 5) {
        return "I’m working with my students on writing complete sentences with proper punctuation and organizing their thoughts into clear paragraphs...";
      }

      if (grade && grade >= 6 && grade <= 8) {
        return "I’m working with my students on crafting engaging introductions with hooks and supporting their ideas with specific details and examples...";
      }

      return "I’m working with my students on developing strong thesis statements and integrating textual evidence with thoughtful analysis and proper citations...";
    },
  },

  criteriaTemplates: {
    name: "e.g., Common Core Writing Criteria",
  },

  summary: {
    edit: "Edit summary...",
  },

  comments: {
    add: "Enter your feedback or comment here...",
  },

  highlights: {
    explainHighlight: "Explain what’s noteworthy about this highlight...",
    suggestImprovement: "Suggest how the student could improve this...",
  },

  feedback: {
    message: "Describe your feedback in detail...",
    replyMessage: "Write your reply...",
  },

  search: {
    logs: "Search logs...",
    feedback: "Search feedback...",
    papers: "Search by student name...",
    students: "Type to search students...",
  },
} as const;

export type PlaceholderString = typeof placeholders;
